import { basePost, baseGet } from "../api/base";

import apiEndPointList from "../constant/apiEndPointsList";

const linkServices = {
    // get all links
    getAllLink: async ({ id_path }: { id_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.link.GET_ALL_LINK(id_path),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi làm mới token");
        }

        return response?.data;
    },

    getLinkByName: async ({ id_path, name }: { id_path: string, name: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.link.GET_LINK_BY_NAME(id_path, name),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi làm mới token");
        }

        return response?.data;
    }

}

export default linkServices;